import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiBtnIcon, JtnUiDefaultBtn } from '@jtnews/jtn-ui';
import { injectStylesMixin, tsStoreMixin } from '@jtnews/shared';

import { createUserFacade, UserFacade } from '../../../../features/user/layers/src';

import styles from './register-success-form.styles.scss?module';

type ComponentData = {
  userFacade: UserFacade | null;
};

type Event = {
  onCloseModal: void;
  onClickedTuneLater: void;
  onClickedProfile: void;
};

const PROFILE_LINK = '/profile/';

export default componentFactoryOf<Event>()
  .mixin(injectStylesMixin(styles))
  .mixin(tsStoreMixin)
  .create({
    name: 'RegisterSuccessForm',
    data(): ComponentData {
      return {
        userFacade: null
      };
    },
    computed: {
      isMobile(): boolean {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      }
    },
    created() {
      this.userFacade = createUserFacade(this.store);
    },
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },
      clickedTuneLater() {
        this.$emit('clickedTuneLater');
        this.closeModal();
      },
      clickedProfile() {
        this.$emit('clickedProfile');
      }
    },
    render() {
      const CLOSE_ICON_SIZE = 18;
      const SMILE_ICON_SIZE = 96;

      return (
        <div class={styles.successBlock}>
          <JtnUiBtnIcon
            class={styles.closeBtn}
            btnType="button-other-type-3"
            size={CLOSE_ICON_SIZE}
            data-test="register-success-close-modal"
            onClick={this.closeModal}
          >
            <svg width={CLOSE_ICON_SIZE} height={CLOSE_ICON_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-close"></use>
            </svg>
          </JtnUiBtnIcon>

          <h3 class={styles.caption}>Вы успешно вошли на сайт!</h3>

          <svg width={SMILE_ICON_SIZE} height={SMILE_ICON_SIZE}>
            <use xlinkHref="/dist/legacy/svg-sprites/jtn-action-result.298c59fd07ca588e2f5a658ed63a7e4b.svg#jtn-action-result-success-result"></use>
          </svg>

          <p class={styles.note}>
            Перейдите в профиль и задайте имя и аватар, которые увидят другие пользователи
          </p>

          <JtnUiDefaultBtn
            class={styles.btn}
            url={PROFILE_LINK}
            data-test="register-success-tune-profile"
            onClick={this.clickedProfile}
          >
            Перейти в профиль
          </JtnUiDefaultBtn>
          <JtnUiDefaultBtn
            class={[styles.btn, styles.laterBtn]}
            btnType="button-other-type-1"
            data-test="register-success-tune-later"
            onClick={this.clickedTuneLater}
          >
            Настроить позже
          </JtnUiDefaultBtn>
        </div>
      );
    }
  });
